<nav class="booking">
    <div class="nav nav-tabs nav-fill" id="nav-tab" role="tablist">
        <a class="nav-item nav-link active" id="nav-home-tab" data-toggle="tab" href="#nav-home"
            role="tab" aria-controls="nav-home" aria-selected="true">
            <i class="fas fa-taxi amr"></i> ONE WAY</a>
        <a class="nav-item nav-link" id="nav-profile-tab" data-toggle="tab" href="#nav-profile"
            role="tab" aria-controls="nav-profile" aria-selected="false">
            <i class="fas fa-city amr"></i> ROUND TRIP
        </a>
    </div>
</nav>
<div id="booking" class="tab-content">
    <div class="tab-pane fade show active" id="nav-home" role="tabpanel" aria-labelledby="nav-home-tab">
        <app-oneway></app-oneway>
    </div>
    <div class="tab-pane fade" id="nav-profile" role="tabpanel" aria-labelledby="nav-profile-tab">
        <app-roundtrip></app-roundtrip>
    </div>
</div>